import { HttpMethod, RequestOptions, useUserRequest } from "../common/lib/fetch";
import { useUser } from "../userAccess/useUser";

const useRemoveSiteUser = (userId: string, options?: RequestOptions<void>) => {
  const user = useUser();

  return useUserRequest<void, void>({
    path: `/api/sites/${user.selectedSite?.id}/users/${userId}`,
    method: HttpMethod.DELETE
  }, options);
}
  
export default useRemoveSiteUser;
